import React from 'react';
import { Icon } from './Icon.js';
export const IconBasketShopping2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M9 2.5L6 8H7", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", strokeLinejoin: "round", fill: "none" }),
        React.createElement("path", { d: "M15 2.5L18 8H17", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", strokeLinejoin: "round", fill: "none" }),
        React.createElement("path", { d: "M5 21L3.5 13.5L2 12.5V8H22V12.5L20.5 13.5L19 21H5Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconBasketShopping2.js.map